import { TemplateResult, html, CSSResultGroup } from 'lit';
import { property } from 'lit/decorators.js';
import { BlocksElement } from '../BlocksElement';
import styles from './anchor-nav-item.styles';

/**
 * @slot default - The component content
 * @csspart base - The component's base wrapper.
 * @csspart part-default - The component's default slot.
 */
export class BlocksAnchorNavItem extends BlocksElement {static styles: CSSResultGroup = styles;

  /**
   * The anchor link section
   */
  @property({ type: String })
  href: string | undefined;

  /**
   * Active state
   */
  @property({ type: Boolean })
  isActive: boolean | undefined;

  /**
   * Click handler
   * 1) On click, smooth scroll to the section.
   */
  private clickHandler(e: Event) {
    e.preventDefault();
    this.scrollToSection();
  }

  /**
   * Scroll function
   */
  public scrollToSection() {
    const sectionId = this.href;
    if (sectionId) {
      setTimeout(() => {
        document.querySelector<HTMLElement>(sectionId)?.scrollIntoView({ behavior: 'smooth' });
      });
    }
  }

  render(): TemplateResult<1> {
    const componentClassNames = this.componentClassNames('cat-c-anchor-nav__item', {
      'cat-is-active': this.isActive
    });

    return html`
      <a part="base" class="${componentClassNames}" href="${this.href ?? ''}" @click=${(e: Event) => this.clickHandler(e)}>
        <slot part="part-default"></slot>
      </a>
    `;
  }
}

if (customElements.get('cat-anchor-nav-item') === undefined) {
  customElements.define('cat-anchor-nav-item', BlocksAnchorNavItem);
}

declare global {
  interface HTMLElementTagNameMap {
    'cat-anchor-nav-item': BlocksAnchorNavItem;
  }
}
